module.exports = __webpack_public_path__ + "web/img/grade1.d991ea9e.png";